import { render } from "./Sroi.vue?vue&type=template&id=88d454f2"
import script from "./Sroi.vue?vue&type=script&lang=js"
export * from "./Sroi.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__